import { render, staticRenderFns } from "./SessionReport.vue?vue&type=template&id=80c4c68e&scoped=true&"
import script from "./SessionReport.vue?vue&type=script&lang=js&"
export * from "./SessionReport.vue?vue&type=script&lang=js&"
import style0 from "./SessionReport.vue?vue&type=style&index=0&id=80c4c68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c4c68e",
  null
  
)

export default component.exports